import React from "react";
import { TextSearch } from "lucide-react";
import PlaceAutocomplete from "./PlaceAutocomplete";
import SearchInput from "./SearchInput";

function SearchSidebarForm({
  searchInputRef,
  termInput,
  onSearchInputChange,
  onSearchInputFocus,
  onSearchKeyDown,
  locationInput,
  onLocationInputChange,
  onPlaceSelect,
  onSubmit,
  showSubmitButton = true,
  idSuffix = "",
  termDropdown = null,
  inputAriaProps = {},
}) {
  const searchId = `search${idSuffix}`;
  const locationId = `location${idSuffix}`;

  return (
    <form onSubmit={onSubmit}>
      <div className="search-form-inputs">
        <div className="search-row">
          <div className="search-item search-term-item">
            <SearchInput
              icon={<TextSearch size={16} strokeWidth={2} />}
              inputRef={searchInputRef}
              containerClassName="search-field-shell--compact"
              inputClassName="category-search-term"
              id={searchId}
              type="text"
              name="term"
              placeholder="Search Food Pantries, Housing, and more"
              value={termInput}
              onChange={onSearchInputChange}
              onFocus={onSearchInputFocus}
              onKeyDown={onSearchKeyDown}
              autoComplete="off"
              {...inputAriaProps}
            />
            {termDropdown}
          </div>
          <div className="search-item">
            <div className="search-group">
              <PlaceAutocomplete
                variant="compact"
                id={locationId}
                name="location"
                placeholder="Search address, city or zip"
                value={locationInput}
                onChange={onLocationInputChange}
                onPlaceSelect={onPlaceSelect}
              />
              {showSubmitButton && (
                <button type="submit" className="search-button btn btn-secondary large" style={{ width: "100%" }}>
                  <i className="ico ico-search" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default SearchSidebarForm;
